import isNode from '../modules/ajio-util/isNode.js';

export function showModal(name, config = {}) {
  console.log("In modal.js")
  if (!isNode()) {
    document.body.classList.add('noScroll');
  }
  return {
    type: 'SHOW_MODAL',
    name,
    config
  };
}

export function updateModal(name, config = {}) {
  return {
    type: 'UPDATE_MODAL',
    name,
    config
  };
}

export function hideModal(name) {
  if (!isNode()) {
    document.body.classList.remove('noScroll');
  }

  return {
    type: 'HIDE_MODAL',
    name
  };
}
